import { SVG_ICONS } from "../components/__common/Svg/Svg";
import { GpsRegion, GPS_REGION_CODE } from "../types/gps-region";

export const GpsRegions: GpsRegion[] = [
  {
    code: GPS_REGION_CODE.LATIN_AMERICA,
    name: "Latin America",
    image: SVG_ICONS.GPS_MAP_LATIN_AMERICA,
    countries: [
      {
        code: "AR",
        name: "Argentina",
        link: "https://sdapla.privacy.samsung.com/privacy/ar",
      },
      {
        code: "BO",
        name: "Bolivia",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "BR",
        name: "Brasil ",
        link: "https://www.samsung.com/br/privacy/",
      },
      {
        code: "CL",
        name: "Chile",
        link: "https://sdapla.privacy.samsung.com/privacy/cl",
      },
      {
        code: "CO",
        name: "Colombia",
        link: "https://sdapla.privacy.samsung.com/privacy/co",
      },
      {
        code: "CR",
        name: "Costa Rica",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "EC",
        name: "Ecuador",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "SV",
        name: "El Salvador",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "GT",
        name: "Guatemala",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "HN",
        name: "Honduras",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "MX",
        name: "México",
        link: "https://sdapla.privacy.samsung.com/privacy/mx",
      },
      {
        code: "NI",
        name: "Nicaragua",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "PA",
        name: "Panamá",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "PY",
        name: "Paraguay",
        link: "https://sdapla.privacy.samsung.com/privacy/py",
      },
      {
        code: "PE",
        name: "Perú",
        link: "https://sdapla.privacy.samsung.com/privacy/pe",
      },
      {
        code: "DO",
        name: "República Dominicana",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "UY",
        name: "Uruguay",
        link: "https://sdapla.privacy.samsung.com/privacy/uy",
      },
    ],
  },
  {
    code: GPS_REGION_CODE.NORTH_AMERICA,
    name: "North America",
    image: SVG_ICONS.GPS_MAP_NORTH_AMERICA,
    countries: [
      { code: "USA", name: "USA", link: "https://www.samsung.com/us/privacy/" },
    ],
  },
  {
    code: GPS_REGION_CODE.ASIA_PACIFIC,
    name: "Asia Pacific",
    image: SVG_ICONS.GPS_MAP_ASIA,
    countries: [
      // {
      //   code: "AU",
      //   name: "Australia",
      //   link: "https://www.samsung.com/au/privacy-support/",
      // },
      {
        code: "CHN",
        name: "中國",
        link: "https://privacy.samsung.com.cn/",
      },
      // {
      //   code: "ID",
      //   name: "Indonesia",
      //   link: "https://www.samsung.com/id/privacy-support/#",
      // },
      // {
      //   code: "MY",
      //   name: "Malaysia",
      //   link: "https://www.samsung.com/my/privacy-support/#",
      // },
      // {
      //   code: "NZ",
      //   name: "New Zealand",
      //   link: "https://www.samsung.com/nz/privacy-support/",
      // },
      // {
      //   code: "PH",
      //   name: "Philippines",
      //   link: "https://privacy.samsung.com.cn/",
      // },
      // {
      //   code: "SG",
      //   name: "Singapore",
      //   link: "https://www.samsung.com/sg/privacy-support/#",
      // },
      // {
      //   code: "TH",
      //   name: "ประเทศไทย",
      //   link: "https://www.samsung.com/th/privacy-support/#",
      // },
      // {
      //   code: "VN",
      //   name: "Việt Nam",
      //   link: "https://www.samsung.com/vn/privacy-support/#",
      // },
    ],
  },
  {
    code: GPS_REGION_CODE.EUROPE,
    name: "Europe",
    image: SVG_ICONS.GPS_MAP_EUROPE,
    countries: [
      {
        code: "EU1",
        name: "Shqipëri ",
        link: "https://www.europe-samsung.com/gdpr/webform/al/",
      },
      {
        code: "EU2",
        name: "Österreich",
        link: "https://www.europe-samsung.com/gdpr/webform/at/",
      },
      {
        code: "EU3",
        name: "Belgium",
        link: "https://www.europe-samsung.com/gdpr/webform/be_fr/",
      },
      {
        code: "EU4",
        name: "България",
        link: "https://www.europe-samsung.com/gdpr/webform/bg/",
      },
      {
        code: "EU5",
        name: "Hrvatska",
        link: "https://www.europe-samsung.com/gdpr/webform/hr/",
      },
      {
        code: "EU6",
        name: "Česká republika",
        link: "https://www.europe-samsung.com/gdpr/webform/cz/",
      },
      {
        code: "EU7",
        name: "Danmark",
        link: "https://www.europe-samsung.com/gdpr/webform/dk/",
      },
      {
        code: "EU8",
        name: "Estonian",
        link: "https://www.europe-samsung.com/gdpr/webform/ee/",
      },
      {
        code: "EU9",
        name: "Suomi",
        link: "https://www.europe-samsung.com/gdpr/webform/fi/",
      },
      {
        code: "EU10",
        name: "France",
        link: "https://www.europe-samsung.com/gdpr/webform/fr/",
      },
      {
        code: "EU11",
        name: "Deutschland",
        link: "https://www.europe-samsung.com/gdpr/webform/de/",
      },
      {
        code: "EU12",
        name: "Ελλάδα",
        link: "https://www.europe-samsung.com/gdpr/webform/gr/",
      },
      {
        code: "EU13",
        name: "Magyarország",
        link: "https://www.europe-samsung.com/gdpr/webform/hu/",
      },
      {
        code: "EU14",
        name: "Iceland",
        link: "https://www.europe-samsung.com/gdpr/webform/is/",
      },
      {
        code: "EU15",
        name: "Ireland",
        link: "https://www.europe-samsung.com/gdpr/webform/ie/",
      },
      {
        code: "EU16",
        name: "Italia",
        link: "https://www.europe-samsung.com/gdpr/webform/it/",
      },
      {
        code: "EU17",
        name: "Latvija",
        link: "https://www.europe-samsung.com/gdpr/webform/lv/",
      },
      {
        code: "EU18",
        name: "Lietuva",
        link: "https://www.europe-samsung.com/gdpr/webform/lt/",
      },
      {
        code: "EU19",
        name: "Luxembourg",
        link: "https://www.europe-samsung.com/gdpr/webform/lu/",
      },
      {
        code: "EU20",
        name: "Malta",
        link: "https://www.europe-samsung.com/gdpr/LanguageSelection#:~:text=LUXEMBOURG%20/%20FRAN%C3%87AIS-,MALTA%20/%20ITALIANO,-NEDERLAND%20/%20NEDERLANDS",
      },
      {
        code: "EU21",
        name: "Nederland",
        link: "https://www.europe-samsung.com/gdpr/webform/nl/",
      },
      {
        code: "EU22",
        name: "Norge",
        link: "https://www.europe-samsung.com/gdpr/webform/no/",
      },
      {
        code: "EU23",
        name: "Polska",
        link: "https://www.europe-samsung.com/gdpr/webform/pl/",
      },
      {
        code: "EU24",
        name: "Portugal",
        link: "https://www.europe-samsung.com/gdpr/webform/pt/",
      },
      {
        code: "EU25",
        name: "Romania",
        link: "https://www.europe-samsung.com/gdpr/webform/ro/",
      },
      {
        code: "EU26",
        name: "Cрбија",
        link: "https://www.europe-samsung.com/gdpr/LanguageSelection#:~:text=ROMANIA%20/%20ROMANIAN-,C%D0%A0%D0%91%D0%98%D0%88%D0%90%20/%20C%D0%A0%D0%9F%D0%A1%D0%9A%D0%98,-",
      },
      {
        code: "EU27",
        name: "Slovensko",
        link: "https://www.europe-samsung.com/gdpr/webform/sk/",
      },
      {
        code: "EU28",
        name: "Slovenija ",
        link: "https://www.europe-samsung.com/gdpr/webform/si/",
      },
      {
        code: "EU29",
        name: "Espana",
        link: "https://www.europe-samsung.com/gdpr/webform/es/",
      },
      {
        code: "EU30",
        name: "Sverige",
        link: "https://www.europe-samsung.com/gdpr/webform/se/",
      },
      {
        code: "EU31",
        name: "Schweiz",
        link: "https://www.europe-samsung.com/gdpr/webform/ch/",
      },
      {
        code: "EU32",
        name: "Türkiye",
        link: "https://kvkk-portal.samsung.com/",
      },
      {
        code: "EU33",
        name: "UK",
        link: "https://www.europe-samsung.com/gdpr/webform/uk/",
      },
    ],
  },
];
